export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const COLOR_OPTIONS = [
  { value: "none", label: "Sin especificar" },
  { value: "Blanco", label: "Blanco" },
  { value: "Negro", label: "Negro" },
  { value: "Gris", label: "Gris" },
  { value: "Natural", label: "Natural" },
  { value: "Anodizado", label: "Anodizado" },
  { value: "Pintura Electrostática", label: "Pintura Electrostática" }
];

export const FACTORY_COLOR_OPTIONS = [
  { value: "White", label: "White" },
  { value: "Black", label: "Black" },
  { value: "Grey", label: "Grey" },
  { value: "Powder Coated", label: "Powder Coated" },
  { value: "Anodized", label: "Anodized" },
  { value: "Natural", label: "Natural" }
];
